import React from 'react';
import { useLanguage } from '@contexts/LanguageContext';
import Icon from '@components/Icon/Icon';

const AttachmentPreviewSection = ({
    file,
    fileUrl,
    isImage,
    getFileIcon,
    getFileType,
    imageLoaded,
    setImageLoaded,
    onPreviewClick
}) => {
    const { t } = useLanguage();

    return (
        <div className="attachment-preview" onClick={onPreviewClick}>
            {isImage ? (
                <div className="image-wrapper">
                    {!imageLoaded && (
                        <div className="image-placeholder">
                            <Icon icon="image" size="2x" />
                            <span className="loading-text">{t('attachments.loading')}</span>
                        </div>
                    )}
                    <img
                        src={fileUrl}
                        alt={file.filename}
                        className={`attachment-image ${imageLoaded ? 'loaded' : 'loading'}`}
                        onLoad={() => setImageLoaded(true)}
                        onError={() => setImageLoaded(false)}
                    />
                </div>
            ) : (
                <div className="file-placeholder">
                    <Icon icon={getFileIcon()} size="2x" className="file-icon" />
                    <span className="file-type">
                        {getFileType()}
                    </span>
                </div>
            )}

            <div className="preview-overlay">
                <Icon icon="eye" />
                <span className="preview-text">{t('attachments.preview')}</span>
            </div>
        </div>
    );
};

export default AttachmentPreviewSection;
